<template>
  <div class="container mt-5">
    <div class="row mt-5" >
      <div class="col-md-12 text-center mt-3">
        <img src="../assets/images/logo.png" alt="MCAlimentos Logo" style="max-width: 300px;" />
      </div>
    </div>

    <div class="row m-4 " v-if="isAdminOrEmployee">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body text-center">
            <h3 class="card-title">
              <i class="bi bi-cart-check me-2"></i>
              Pedidos Pendientes
            </h3>
            <p class="display-4 text-warning mb-3">{{ pendingOrdersCount }}</p>
            <a href="/client_orders" class="btn btn-warning">
              Ver Pedidos
            </a>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body text-center">
            <h3 class="card-title">
              <i class="bi bi-receipt me-2"></i>
              Ventas Pendientes
            </h3>
            <p class="display-4 text-warning mb-3">{{ pendingSalesCount }}</p>
            <a href="/sales" class="btn btn-warning">
              Ver Ventas
            </a>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body text-center">
            <h3 class="card-title">
              <i class="bi bi-box-seam me-2"></i>
              Compras Pendientes
            </h3>
            <p class="display-4 text-warning mb-3">{{ pendingPurchasesCount }}</p>
            <a href="/purchases" class="btn btn-warning">
              Ver Compras
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-4 " v-if="isAdmin">
      <div class="col-md-4">
        <div class="alert" :class="globalStatus?.total_amount_clients < 0 ? 'alert-danger' : 'alert-success'">
          Estado de cuenta clientes: {{ formatCurrency(globalStatus?.total_amount_clients) }} 
        </div>
      </div>

      <div class="col-md-4">
        <div class="alert" :class="globalStatus?.total_amount_financials < 0 ? 'alert-danger' : 'alert-success'">
          Estado de cuenta financieras: {{ formatCurrency(globalStatus?.total_amount_financials) }} 
        </div>
      </div>

      <div class="col-md-4">
        <div class="alert" :class="globalStatus?.total_amount_suppliers > 0 ? 'alert-danger' : 'alert-success'">
          Estado de cuenta proveedores: {{ formatCurrency(globalStatus?.total_amount_suppliers) }} 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      pendingOrdersCount: 0,
      pendingSalesCount: 0,
      pendingPurchasesCount: 0,
      globalStatus: null,
      loading: true,
      userRole: null
    };
  },
  computed: {
    isAdminOrEmployee() {
      return this.userRole === 'Admin' || this.userRole === 'Empleado';
    },
     isAdmin() {
      return this.userRole === 'Admin';
    }

  },
  mounted() {
    // Get user role from data attribute
    const appElement = document.getElementById('app');
    this.userRole = appElement?.getAttribute('data-user-role');

    // Only fetch orders, sales, and purchases if user is admin or employee
    if (this.isAdminOrEmployee) {
      this.fetchPendingOrders();
      this.fetchPendingSales();
      this.fetchPendingPurchases();
    } else {
      window.location.replace('/client_orders');
      this.loading = false;
    }

    if (this.isAdmin) {
      this.fetchGlobalStatus();
    }
  },
  methods: {
    async fetchPendingOrders() {
      try {
        this.loading = true;
        const response = await axios.get('/client_orders/count.json');
        this.pendingOrdersCount = response.data.count;
      } catch (error) {
        console.error('Error fetching client orders:', error);
        this.pendingOrdersCount = 0;
      } finally {
        this.loading = false;
      }
    },
    async fetchPendingSales() {
      try {
        const response = await axios.get('/sales/count.json');
        this.pendingSalesCount = response.data.count;
      } catch (error) {
        console.error('Error fetching sales:', error);
        this.pendingSalesCount = 0;
      }
    },
    async fetchPendingPurchases() {
      try {
        const response = await axios.get('/purchases/count.json');
        this.pendingPurchasesCount = response.data.count;
      } catch (error) {
        console.error('Error fetching purchases:', error);
        this.pendingPurchasesCount = 0;
      }
    },
    async fetchGlobalStatus() {
      try {
        this.loading = true;
        const response = await axios.get('/global_balance.json');
        this.globalStatus = response.data;
      } catch (error) {
        console.error('Error fetching global_balance:', error);
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS'
      }).format(amount || 0);
    }
  }
}
</script>

<style scoped>
.display-4 {
  font-weight: 700;
}
</style>

